module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-regular.b7b7c77b.woff";